import React from 'react';
import PropTypes from 'prop-types';

import styles from './prepaidCard.module.scss';

const ImageDetail = ({ label, detail, image }) => {
  return (
    <div className={styles.copyableDetailOuterContainer}>
      <div className={styles.copyableDetailLabelContainer}>
        <p className={styles.copyableDetailLabel}>{label}</p>
      </div>
      <div className={styles.copyableDetailContainer}>
        <div className={styles.copyableDetailLabelDetailContainer}>
          <p className={styles.copyableDetailDetail}>{detail}</p>
        </div>
        {image}
      </div>
    </div>
  );
};

ImageDetail.propTypes = {
  label: PropTypes.string.isRequired,
  image: PropTypes.node.isRequired,
  detail: PropTypes.node.isRequired,
};

export default ImageDetail;
